export const data_projects = [
    {
        id: 1,
        name: "CASPER",
        description: "CASPER (<i>Contextual Assistant for Smart Environments Problems Explanation and Resolution</i>) is an intelligent system designed to help users create, manage and understand IoT automations. It continuously analyses automation rules to detect conflicts, unwanted activation chains and misalignments with user goals, providing clear explanations and proposing tailored solutions to improve comfort, well-being and energy efficiency. The project showcases skills in rule analysis, automation reasoning, system design and user-centered explanation of complex behaviors through visual and conversational interaction.",
        video: "casper_demo.mp4",
        github: "https://github.com/saramaenza/CASPER",
        technologies: [
            "JavaScript", 
            "HTML", 
            "CSS", 
            "Python", 
            "REST APIs", 
            "Fetch APIs", 
            "Bootstrap",
            "MongoDB"
        ],
        demo: "https://rulebot.isti.cnr.it/casper/"
    },
    {
        id: 2,
        name: "CryptoLens",
        description: "CryptoLens is a React-based web application designed to explore and monitor cryptocurrencies through real-time market data, detailed asset information, and historical price charts. The application integrates the CoinGecko API to retrieve up-to-date cryptocurrency prices, market capitalization, trading volume, and price variations. Interactive charts powered by Chart.js and react-chartjs-2 allow users to visualize market trends over time, while a favorites system enables quick access to selected assets. The project emphasizes data visualization, state management, and a clean, responsive UI to make complex financial data easy to understand and navigate.",
        video: "cryptolens_demo.mp4",
        github: "https://github.com/saramaenza/CryptoLens",
        technologies: [
            "React",
            "JavaScript",
            "Tailwind CSS",
            "REST APIs",
            "Fetch API",
            "CoinGecko API",
            "Chart.js",
        ],
        demo: "https://cryptolens-react.vercel.app/"
    },
    {
        id: 3,
        name: "City Explorer",
        description: "City Explorer is a React web application that allows users to search for a city and explore current weather, weather forecast, detailed city information (population, timezone, coordinates), a city-related background image, and a list of main attractions from Wikidata. The app uses an API-driven autocomplete to ensure only valid cities can be selected, improving data reliability and preventing errors. It combines multiple external APIs into a smooth, responsive interface, with careful handling of loading, empty, and error states to provide a clear and user-friendly experience.",
        video: "city_explorer_demo.mp4",
        github: "https://github.com/saramaenza/City-Explorer",
        technologies: [
            "React",
            "JavaScript",
            "Tailwind CSS",
            "REST APIs",
            "Fetch API",
            "SPARQL",
            "GeoDB Cities API",
            "OpenWeather API",
            "Unsplash API",
            "Wikidata"
        ],
        demo: "https://city-explorer-ten.vercel.app/"
    },
    {
        id: 4,
        name: "Portfolio Website",
        description: "This project is my personal portfolio website, designed and developed to present my projects, skills, and professional profile in a clear and engaging way. Built with React and Tailwind CSS, the site focuses on a clean layout, smooth navigation, and responsive design across devices. It serves as a central hub to showcase selected works, provide access to live demos and source code, and communicate my approach to front-end development with an emphasis on usability, visual consistency, and maintainable component-based architecture.",
        video: "portfolio_demo.mp4",
        github: "https://github.com/saramaenza/Portfolio",
        technologies: [
            "React", 
            "JavaScript", 
            "Tailwind CSS"
        ],
        demo: "https://saramaenza-dev.vercel.app/"
    }
]